import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { ClientsComponent } from './clients.component';
import { ClientComponent } from './client/client.component';
import { ClientHeaderDetailsComponent } from './client/client-header-details/client-header-details.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ClientsComponent, ClientComponent, ClientHeaderDetailsComponent],
  entryComponents: [ClientHeaderDetailsComponent],
  exports: [ClientsComponent, ClientComponent]
})
export class ClientsModule { }
